import { useRef, useState } from "react";
import Select, {InputAction} from 'react-select';
import { Modal } from 'react-responsive-modal';
import makeAnimated from 'react-select/animated'
import ToggleInput from "./inputs/ToggleInput";
import { useCollectionContext } from "../context/CollectionContext";
import { db } from "../db";
import Swal from "sweetalert2";
import { updateImageTags } from "../api-helper";
import { useAccountContext } from "../context/AccountContext";
import { isUndefined } from "cropperjs";

const animatedComponents = makeAnimated()

export default function FullImageViewer(props){
    const collectionContext = useCollectionContext()
    const accountContext = useAccountContext()

    const imageContainerRef = useRef(null);
    const [transform, setTransform] = useState({
      scale: 1,
      translateX: 0,
      translateY: 0,
    });
    const [isDragging, setIsDragging] = useState(false);
    const [lastMousePosition, setLastMousePosition] = useState({ x: 0, y: 0 });
    const [open, setOpen] = useState(false)
    const [options, setOptions] = useState([]); 
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [inputTag, setInputTag] = useState("");
    const [tag, setTag] = useState(props.tag)
    const [tagLoading, setTagLoading] = useState(false);
  
    const handleWheel = (e) => {
    //   e.preventDefault();
  
      const container = imageContainerRef.current;
      if (!container) return;
  
      const { left, top, width, height } = container.getBoundingClientRect();
      const { scale, translateX, translateY } = transform;
  
      const zoomIntensity = 0.1;
      const newScale = e.deltaY > 0 ? scale - zoomIntensity : scale + zoomIntensity;
  
      if (newScale < 1) {
        setTransform({
          scale: 1,
          translateX: 0,
          translateY: 0,
        });
        return;
      }
  
      let newTranslateX = translateX;
      let newTranslateY = translateY;
  
      if (e.deltaY < 0) { // Zooming in relative to the cursor
        const mouseX = (e.clientX - left) / width;
        const mouseY = (e.clientY - top) / height;
  
        const deltaScale = newScale - scale;
        newTranslateX = translateX - (mouseX * width * deltaScale);
        newTranslateY = translateY - (mouseY * height * deltaScale);
      } else { // Zooming out, keep the image centered
        const deltaScale = newScale - scale;
        newTranslateX = translateX - (width / 2) * deltaScale;
        newTranslateY = translateY - (height / 2) * deltaScale;
      }
  
      setTransform({
        scale: newScale,
        translateX: newTranslateX,
        translateY: newTranslateY,
      });
    };
  
    const handleMouseDown = (e) => {
      setIsDragging(true);
      setLastMousePosition({ x: e.clientX, y: e.clientY });
    };
  
    const handleMouseMove = (e) => {
      if (!isDragging) return;
  
      const { x, y } = lastMousePosition;
      const deltaX = e.clientX - x;
      const deltaY = e.clientY - y;
  
      setTransform((prevTransform) => ({
        ...prevTransform,
        translateX: prevTransform.translateX + deltaX,
        translateY: prevTransform.translateY + deltaY,
      }));
  
      setLastMousePosition({ x: e.clientX, y: e.clientY });
    };
  
    const handleMouseUp = () => {
      setIsDragging(false);
    };
  
    const imageStyle = {
      transform: `scale(${transform.scale}) translate(${transform.translateX / transform.scale}px, ${transform.translateY / transform.scale}px)`,
      transformOrigin: '0 0',
      transition: isDragging ? 'none' : 'transform 0.1s ease-out',
      cursor: isDragging ? 'grabbing' : 'grab',
    };

    const openTagModal = () => {
        setOptions([]);

        const combinedTags = [...collectionContext.tags, ...collectionContext.collectionTags];
        const uniqueTags = [...new Set(combinedTags)];

        const sortedTags = uniqueTags.sort((a, b) => a.localeCompare(b));
        setOptions(sortedTags.map(tag => ({ value: tag, label: tag })));
        setOpen(true);
    }

    const editTagOnImage = () => {
        setTagLoading(true);
        let multiOptions = "";
        let initTag
        let concate

        setTimeout(() => {
            if (isUndefined(props.tag) == false) {
                initTag = props.tag + ","
            } else {
                initTag = "";
            }
            if (selectedOptions !== "" && !selectedOptions.includes("undefined")) {
                selectedOptions.map((arrValue) => {
                    if (!initTag.includes(arrValue.value)){
                        multiOptions += arrValue.value + ",";
                    }
                })
                initTag += multiOptions;
            }


        }, 1000)

        setTimeout(() => {
            if (inputTag !== "") {
                if (!initTag.includes(inputTag)){
                    concate = initTag + inputTag
                } else {
                    concate = initTag
                }
            } else {
                concate = initTag;
            }   
            if (concate.endsWith(',')) {
                concate = concate.slice(0, -1);
            }
            if (concate.startsWith(',')) {
                concate = concate.substring(1);
            }
            if (concate == '') {
                Swal.fire({
                    color: "#190A4E",
                    title: "Tag Empty",
                    text: "You cannot tag an image with an empty tag. Please add a tag to the image before proceeding.",
                    icon: "info",
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: false
                })
                setTagLoading(false);
                return;
            }  
            setTag(concate)
            db.images.update(props.id, {tag: concate}).then(async(updated) => {
                if (updated) {
                    if (props.isMyCollection) {
                        // Update the tag in the images table if it exists
                        let generatedImages = [];
                        await db.images.reverse().toArray((images) => {
                            generatedImages = images;
                        });
                        let imageInImagesTable;
                        generatedImages.forEach((image) => {
                            if (image.hash === props.hash) {
                                imageInImagesTable = image;
                            }
                        })
                        if (imageInImagesTable) {
                            db.images.update(imageInImagesTable.id, { tag: concate });
                        } else {
                            console.log("Image not found in the images table");
                        }
                        console.log("Update Image Tags Route: ", props.hash);
                        updateImageTags(accountContext.accountDetails.accountNo, props.hash, concate)

                    } else {
                        let collectionImages = [];
                        await db.collectedImages.reverse().toArray((images) => {
                            collectionImages = images;
                        });
                        let imageInCollectionTable;
                        collectionImages.forEach((image) => {
                            if (image.hash === props.hash) {
                                imageInCollectionTable = image;
                            }
                        })
                        if (imageInCollectionTable) {
                            db.collectedImages.update(imageInCollectionTable.id, { tag: concate });
                        } else {
                            console.log("Image not found in the collection table");
                        }
                    }
                    Swal.fire({
                        title:"Success",
                        text:"Your image was successfully tagged",
                        icon:"success",
                        timer: 1000,
                        showConfirmButton: false
                    }).then(() => {
                        setTagLoading(false);
                        setInputTag("");
                        // setClearTags(false);
                        setSelectedOptions([]);
                        // if (!props.isMyCollection) {
                        //     props.refreshImages();
                        // }
                        props.setTag(concate)
                    })
                    setOpen(false)
                }
            })

        }, 2500)

    }

    const handleEnter = (e) => {
        if (e.key === "Enter") {
            editTagOnImage();
        }
    }

    return (
        <div>
            <div ref={imageContainerRef}  onWheel={handleWheel} onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp} onMouseLeave={handleMouseUp}>
                <img className={"w-full h-full relative"} src={`data:image/png;base64,${ props.image }`} alt={`Generated image: ${ props.seed }`} style={imageStyle} draggable={false}/>
                {tag ? 
                    <div className={`absolute flex flex-col gap-3 group-hover:hidden bottom-0 left-0 rounded-tr px-3 py-2 bg-dark-blue/70 text-sm w-44`}>
                        <p className="text-lg font-semibold">Image Tag</p>
                        <p className="text-yellow font-bold text-lg my-1">{tag}</p>    
                        <button className="rounded-lg bg-yellow py-2 px-3 shadow-md font-bold text-m uppercase" onClick={openTagModal}>Add Tag(s)</button>
                    </div>
                :
                    <div className={`absolute flex flex-col gap-3 group-hover:hidden bottom-0 left-0 rounded-tr px-3 py-2 bg-dark-blue/70 text-sm w-44`}>
                        <p className="text-lg font-semibold">Add Image Tag</p>
                        <button className="rounded-lg bg-yellow py-2 px-3 shadow-md font-bold text-m uppercase" onClick={openTagModal}>Add Tag(s)</button>
                    </div>
                }
            </div>
            <Modal open={open} onClose={() => setOpen(false)} center>
                                <h2 className="text-2xl mb-5 font-bold">Category</h2>
                                <p>
                                    Edit the tags you would like to add with the image
                                </p>
                                <div className="flex flex-row items-center justify-between my-5">
                                    <p className="place-content-start">Original Tag: <span className="font-bold">{props.tag}</span></p>
                                </div>
                                <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                                    <label className="block mb-2 text-sm font-medium" htmlFor="existing">Existing Category</label>
                                    <Select options={options} components={animatedComponents} onChange={(e) => setSelectedOptions(e)} isMulti isClearable onKeyDown={(e) => handleEnter(e)}/>
                                </div>
                                <div className="flex flex-row items-center">
                                    <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                                    <h1 className="mx-4 font-bold text-xl">OR</h1>
                                    <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                                </div>
                                    <p>
                                        Type in a new category to have more ease in sorting your images
                                    </p>
                                    <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                                        <label className="block mb-2 text-sm font-medium" htmlFor="emailAddress">New Category</label>
                                        <input type="text" name="emailAddress" className="w-full rounded-lg text-dark-blue border border-dark-blue p-2" placeholder="Category"
                                        value={inputTag} onChange={(e) => setInputTag(e.target.value)} onKeyDown={(e) => handleEnter(e)}/>
                                    </div>
                                <div className="flex flex-row justify-center gap-4">
                                    <button onClick={() => editTagOnImage()} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold">
                                        {tagLoading ?
                                                <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffb02e"/>
                                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                                </svg>
                                            :
                                                null
                                        }
                                        Categorize
                                    </button>
                                    <button onClick={() => setOpen(false)} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-dark-blue text-yellow shadow font-bold">Cancel</button>
                                </div>
                            </Modal>
        </div>
    )
}